import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import TextField from '@material-ui/core/TextField'

import Table from '@nocode-works/template/components/table/SimpleTable'
import Window from '@nocode-works/template/components/dialog/Window'

import routerActions from '@nocode-works/template/store/modules/router'
import templateSelectors from 'store/selectors/template'
import websiteActions from '@nocode-works/template/store/modules/website'
import icons from '@nocode-works/template/icons'

const TemplateIcon = icons.template

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    flexGrow: 1,
  },
  actionButton: {
    margin: theme.spacing(1),
  },
}))

const FIELDS = [{
  title: 'Name',
  name: 'name',
}, {
  title: 'Version',
  name: 'version',
}]

const TemplateList = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  
  const data = useSelector(templateSelectors.templates)

  const onView = useCallback((item) => {
    dispatch(routerActions.navigateTo('template.view', {id: item.id}))
  })

  const tableData = useMemo(() => {
    return data.map(template => {
      return {
        id: template.id,
        name: template.name,
        version: template.version,
      }
    })
  }, [
    data,
  ])

  const getActions = useCallback((item) => {
    return (
      <>
        <Button
          size="small"
          color="secondary"
          variant="outlined"
          className={ classes.actionButton }
          onClick={ () => onView(item) }
        >
          <TemplateIcon />&nbsp;&nbsp;View
        </Button>
      </>
    )
  })

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <div className={ classes.title }>
          <Typography gutterBottom variant="h6">
            Templates
          </Typography>
        </div>
      </div>
      <div className={ classes.content }>
        <Table
          data={ tableData }
          fields={ FIELDS }
          getActions={ getActions }
        />
      </div>
    </div>
  )
}

export default TemplateList